import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from "@angular/flex-layout";
import { MaterialModule } from "./material.module";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SidenavListComponent } from './components/sidenav-list/sidenav-list.component';
import { LoadingComponent } from './components/loading/loading.component';
import { ClickOutsideModule } from "ng-click-outside";
import { NgxPopperModule } from "ngx-popper";
import { MatTableExporterModule } from "mat-table-exporter";



@NgModule({
  declarations: [
    SidenavListComponent,
    LoadingComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MaterialModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ClickOutsideModule,
    NgxPopperModule.forRoot(),
    MatTableExporterModule.forRoot({xlsxLightWeight: true})
  ],
  exports: [
    SidenavListComponent,
    LoadingComponent,
    FlexLayoutModule,
    MaterialModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ClickOutsideModule,
    NgxPopperModule,
    MatTableExporterModule
  ]
})
export class SharedModule { }
